export default __webpack_public_path__ + "static/media/uv0_kr_rudl_a2.317a5964.mp3";